import { useNode } from "@craftjs/core";
import React, { useContext, useLayoutEffect, useState } from "react";
import { APIProviderContext } from "../../api";
import {
  UnitInput,
  Spacer,
  Tabs,
  AlignInput,
  TextInput,
  Notice,
  SelectInput,
} from "../../input";
import { supportLibrary } from "../../block-supports";
import { isUpdatedFromDefault } from "../../utils";
import { INPUT_LIMITS } from "../../input-limits";

export const ProductHuntSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
    dom,
    supports,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
    dom: node.dom,
    supports: node.data?.type?.craft?.related?.supports,
  }));
  const { getProductHuntPost } = useContext(APIProviderContext);

  const {
    url,
    post,
    theme,
    width,
    widthTablet,
    widthMobile,
    embedType,
    align,
    alignTablet,
    alignMobile,
  } = props;

  function GeneralSettings() {
    const [productHuntError, setProductHuntError] = useState(false);
    return (
      <div className="g-settings__wrapper">
        <Spacer spacing={"1rem"}>
          <TextInput
            minLength={INPUT_LIMITS["outbound-link"].minlength}
            maxLength={INPUT_LIMITS["outbound-link"].maxlength}
            isResponsive={true}
            resetValue={undefined}
            value={url}
            onChange={(val) => {
              setProp((props) => {
                props.url = val;
              });
            }}
            onBlur={(e) => {
              if (!url) return;

              // Remove query params
              var urlTmp = new URL(url);
              urlTmp.search = "";
              urlTmp = urlTmp.toString();

              setProp((props) => {
                props.url = urlTmp;
              });

              getProductHuntPost(urlTmp)
                .then((res) => {
                  setProductHuntError(false);
                  setProp((props) => {
                    props.post = res;
                  });
                })
                .catch((error) => {
                  console.log(error);
                  // setProductHuntError(error.response.data);
                });
            }}
            label={"Product Hunt URL"}
          />

          {productHuntError && (
            <div className="mt-4">
              <Notice
                text={productHuntError.errors[0].error_description}
                status="error"
              />
            </div>
          )}

          <SelectInput
            resetValue={undefined}
            value={theme}
            onChange={(val) => {
              setProp((props) => {
                props.theme = val;
              });
            }}
            options={[
              { label: "Light", value: "light" },
              { label: "Neutral", value: "neutral" },
              { label: "Dark", value: "dark" },
            ]}
            label="Theme"
          />
          <SelectInput
            resetValue={undefined}
            value={embedType}
            onChange={(val) => {
              setProp((props) => {
                props.embedType = val;
              });
            }}
            options={[
              { label: "Drive Support", value: "drive-support" },
              { label: "Product of the day", value: "product-of-the-day" },
              { label: "Product of the Week", value: "product-of-the-week" },
              // { label: "Category of Month", value: "category-of-month" },
              // { label: "Category of week", value: "category-of-week" },
            ]}
            label="Embed Type"
          />
          {(embedType === "product-of-the-day" ||
            embedType === "product-of-the-week") && (
            <div className="mt-4">
              <Notice
                text={"Only use this proof if you unlocked!"}
                status="info"
              />
            </div>
          )}
          <UnitInput
            isResponsive={true}
            valueTablet={widthTablet}
            valueMobile={widthMobile}
            resetValue={undefined}
            resetValueMobile={undefined}
            resetValueTablet={undefined}
            value={width}
            onChange={(val) => {
              setProp((props) => {
                props.width = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.widthTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.widthMobile = val;
              });
            }}
            label={"Width"}
          />
          <AlignInput
            value={align}
            isResponsive={true}
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            valueTablet={alignTablet}
            valueMobile={alignMobile}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.alignTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.alignMobile = val;
              });
            }}
            label={"Align"}
          />
        </Spacer>
        {supports &&
          supports.map((support) => {
            var Component = supportLibrary[support]?.component;

            if (!Component) {
              return;
            }

            return (
              <>
                <Component
                  block={{
                    id,
                    props,
                    dom,
                  }}
                  actions={{
                    setProp,
                  }}
                ></Component>
              </>
            );
          })}
      </div>
    );
  }

  const tabs = [
    {
      label: "General",
      key: "general",
      children: GeneralSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: url },
        { key: align },
        { key: alignTablet },
        { key: alignMobile },
      ]),
    },
  ];

  return (
    <div>
      <Tabs items={tabs} id={`block-settings-tab-${id}`} />
    </div>
  );
};
